import { trackEvent } from "infra/helpers/event";

export enum FeriadosEventsEnum {
  IniciarCadastro = "Feriados_IniciarCadastro",
  IniciarEdicao = "Feriados_IniciarEdicao",
  Criar = "Feriados_Criar",
  Atualizar = "Feriados_Atualizar",
  Excluir = "Feriados_Excluir",
  CancelarExclusao = "Feriados_CancelarExclusao",
  Ver = "Feriados_Ver",
}

export function verFeriados(id: string) {
  trackEvent(FeriadosEventsEnum.Ver, { id });
}

export function iniciarCadastro() {
  trackEvent(FeriadosEventsEnum.IniciarCadastro);
}

export function iniciarEdicao(id: string) {
  trackEvent(FeriadosEventsEnum.Ver, { id });
  trackEvent(FeriadosEventsEnum.IniciarEdicao, { id });
}

export function criar() {
  trackEvent(FeriadosEventsEnum.Criar);
}

export function atualizar(id: string) {
  trackEvent(FeriadosEventsEnum.Atualizar, { id });
}

export function excluir(id: string) {
  trackEvent(FeriadosEventsEnum.Excluir, { id });
}

export function cancelarExclusao(id: string) {
  trackEvent(FeriadosEventsEnum.CancelarExclusao, { id });
}

const FeriadosEvents = {
  verFeriados,
  iniciarCadastro,
  iniciarEdicao,
  cancelarExclusao,
  criar,
  atualizar,
  excluir,
};

export default FeriadosEvents;
